import React, { useState } from 'react';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import { EvolutiescoreRegisterTable } from './EvolutiescoreRegisterTableMobile';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { InfoPanelMobile } from '../../InfoPanelMobile/InfoPanelMobile';
import { BarChartDeltaRelMobile } from '../../BarChart/BarChart';

export const EvolutiescoreRegisterMobile = (props: any) => {
  const { data, allIndicators, interactieveToolPath, clickHandler } = props;
  const {
    selectedGemeente,
    selectedTopic,
    interfaceColor,
    locale,
    radarColors,
    deltaColors,
  } = useData();

  const [keysInStack, setKeysInStack] = useState([
    'valueReal',
    'valueRealVorig',
  ]);

  const [colorsBar, setColorsBar] = useState(radarColors);

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <Tooltip>
            <TooltipTrigger style={{ marginBottom: '2px' }}>
              <h5 className="page-title-mobile">
                Hoe evolueert {selectedGemeente.label} op enkele
                registerindicatoren?{' '}
                <MdHelpOutline
                  style={{
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: interfaceColor,
                    top: '2px',
                    position: 'relative',
                    display: 'inline',
                  }}
                />
              </h5>
            </TooltipTrigger>
            <TooltipContent className="TooltipMobile">
              <p>
                In de tabel tonen we het meest recente cijfer en het cijfer van
                drie jaar eerder.
              </p>
              <br />
              <p>
                In de grafiek brengen we de relatieve toename/afname in beeld.
                <br />
                Dit doen we omdat de indicatoren verschillende eenheden hebben.
                <br />
                <br />
                De berekening is als volgt:{' '}
                <span style={{ color: 'yellow' }}>
                  ( {selectedGemeente.label} (meest recente meetpunt) -{' '}
                  {selectedGemeente.label} (drie jaar eerder) ) /{' '}
                  {selectedGemeente.label} (drie jaar eerder).
                </span>
                <br />
                <br />
                Deze berekening laat toe om de indicatoren te rangschikken van
                grootste toename tot grootste afname.
              </p>
              <br />
              <p>
                In de interactieve toepassing vind je alle indicatoren terug per
                thema.
              </p>
              <p>
                Via de knop 'Meer informatie' kan je per indicator meteen naar
                de interactieve toepassing gaan.
              </p>
            </TooltipContent>
          </Tooltip>
          <p className={'page-subtitle-mobile'}>
            Op welke indicatoren uit registerdatabanken voor het thema{' '}
            {selectedTopic.thema} scoort {selectedGemeente.label} hoger dan drie
            jaar eerder? En op welke lager?
          </p>{' '}
          <div>
            <InfoPanelMobile
              allIndicators={allIndicators}
              data={data}
              interactieveToolPath={interactieveToolPath}
            />
          </div>
          <hr style={{ marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia style={{ width: '100%' }}>
        {data !== undefined && data.length > 0 ? (
          <Grid container sx={{ maxHeight: '100%' }}>
            <Grid item xs={12} sx={{ height: '40px' }}>
              <h5 style={{ textAlign: 'center', fontSize: '14px' }}>
                <span style={{ color: colorsBar[0] }}>
                  Meest recente meetpunt
                </span>{' '}
                versus{' '}
                <span style={{ color: colorsBar[1] }}>drie jaar eerder</span>
              </h5>
            </Grid>
            <Grid item xs={12}>
              <EvolutiescoreRegisterTable
                keysInStack={keysInStack}
                colorsBar={colorsBar}
                data={data}
              />
            </Grid>
            <Grid item xs={12} sx={{ height: '80px', paddingTop: '30px' }}>
              <h5 style={{ textAlign: 'center', fontSize: '14px' }}>
                Relatieve <span style={{ color: deltaColors[1] }}>afname</span>{' '}
                of <span style={{ color: deltaColors[0] }}>toename</span>
              </h5>
            </Grid>
            <Grid item xs={12} sx={{ height: data.length * 44 + 86 }}>
              <BarChartDeltaRelMobile
                data={data}
                colors={deltaColors}
                locale={locale}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
    </Card>
  );
};
